import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type UpdateLocationBusinessHoursMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateAccountLocationBusinessHoursInput;
}>;

export type UpdateLocationBusinessHoursMutationResult = { __typename?: 'Mutation' } & {
  updateAccountLocationBusinessHours?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateAccountLocationBusinessHoursPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateLocationBusinessHoursDocument = gql`
  mutation updateLocationBusinessHours($input: UpdateAccountLocationBusinessHoursInput!) {
    updateAccountLocationBusinessHours(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
